var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/withMentions.ts";
export function withMentions(editor) {
  const {
    isInline,
    isVoid
  } = editor;

  editor.isInline = element => element.type === 'mention' ? true : isInline(element);

  editor.isVoid = element => element.type === 'mention' ? true : isVoid(element);

  return editor;
}